export default {
  Andpenalties: 'Daños y sanciones liquidados',
  DeliveryFailed: 'Delivery failed, refunds are borne by Party A',
  abandonedRequests: 'Pedido Abandonado',
  abandonedorder: 'Pedido Abandonado',
  accesshelpcenter: 'Accede a nuestro centro de ayuda',
  accessoriesLessDelivery:
    'Lack of accessories, less delivery, refunds are borne by Party A',
  accesstoken: 'Token de Acceso',
  accessurlexample: 'Ejemplo: your-store.com',
  accessurlprefix:
    'La URL no puede contener los siguientes valores: www., https://, http://, /',
  actions: 'Ações',
  activate: 'activar',
  activateStore:
    'Si vas a usar nuestra tienda en línea, actívala para liberar todos los registros DNS.',
  active: 'ACTIVO',
  active2: 'Activo',
  actuallyPrice: 'Precio actual',
  addDomainTips1: 'Vincula un dominio que ya te pertenece.',
  addDomainTips2:
    'También puedes enlazar un subdominio. Asegúrate de comenzar tu formulario con "pay" o "pago". Ej.:',
  addDomainTips3: 'No uses',
  addDomainTips4: '¡Atención! Para que tu dominio funcione,',
  addDomainTips5:
    'necesitas comprarlo y configurarlo con un servicio de hosting',
  addDomainTips6: 'u otro.',
  addDomainTips7: 'Si tienes alguna duda, consulta nuestro',
  addPopup: 'Añadir cupones',
  addastore: 'Añadir una tienda',
  addstore: 'añadir tienda',
  afterEachSuccessful:
    'Después de cada transacción exitosa de la Parte B, la Parte A retirará el 5% del monto de la transacción exitosa de la Parte B y mantendrá el margen rotatorio en la cuenta de la Parte A mientras lo transfiere a la Parte B. El margen rotatorio en la cuenta de la Parte A para cada transacción se mantendrá durante 45 días y el monto se liberará a la Parte B después de 45 días.',
  afterSales:
    'Correo electrónico de postventa, los clientes envían problemas postventa a este correo, y el equipo de soporte responderá.',
  afterVerification:
    'Si el motivo del reembolso cae en las siguientes cinco situaciones después de la verificación, el reembolso será asumido por la Parte B:',
  agreetoNY: 'Al crear una cuenta, aceptas los',
  alreadyhaveanaccount: '¿Ya tienes una cuenta?',
  and: 'y',
  apikey: 'Clave API / ID de cliente',
  apisecretkey: 'Clave secreta de la API / Secreto',
  ativo: 'ACTIVO',
  backgroundColor: 'Color de Fondo',
  basicinformation: 'Información básica',
  blacklisted:
    'If the customer is blacklisted, the refund shall be cancelled and borne by Party B',
  blacklistedCustomer: 'Cliente en lista negra, cancelación de reembolso',
  borneByParty: `Due to Party B's failure to pay in time, the customer requests to cancel the order, and the refund shall be borne by Party B`,
  borneParty:
    'If the product is not satisfactory (does not like it), the refund shall be borne by Party A',
  buttonText: 'Texto del Botón',
  cancel: 'cancelar',
  cancellationAnd:
    'If the order is not shipped and the customer requests cancellation and refund, the refund shall be borne by Party B',
  cardPaymentsAnswer:
    'Una vez que el cliente realice el pago en nuestra cuenta, el mismo será transferido a su billetera al día siguiente.',
  cardPaymentsTitile:
    '¿Cuánto tiempo tarda en transferirse el importe a mi cuenta después de que los clientes realizan pedidos?',
  carddesc: 'TARJETAS, BOLETO, DEPÓSITO BANCARIO Y PIX',
  changeAddress:
    'For requests to change the address after the goods have been shipped, the refund shall be borne by Party B',
  classic: 'Clásico',
  collaboratorRequestCode:
    'Permisos y códigos de colaborador de la tienda (Nuestro correo electrónico es _email_, por favor procese el permiso)',
  collapsemenu: 'Colapsar menú',
  confirm: 'Confirmar',
  confirmedAndThe:
    'If the order is to be confirmed and the customer does not reply for more than 2 days, the refund shall be borne by Party B',
  confirmpassword: 'Confirme su contraseña',
  contentTerms: 'Términos de contenido',
  convertedOrderPaid: 'Pedido realizado (pagado)',
  convertedOrderUnpaid: 'Pedido realizado (no pagado)',
  copy: 'copiar',
  correspondingPenalties:
    'La Parte B debe cumplir con las leyes y regulaciones, así como con los requisitos de gestión de riesgos de la Parte A y de la organización emisora de tarjetas para las transacciones ilegales. Si la Parte B incumple alguna de estas regulaciones, estará sujeta a las penalizaciones y multas correspondientes.',
  countdownImage: 'Tiempo de validez de la cuenta atrás',
  countdownTimer: 'Temporizador',
  countdownBg: 'Fondo contador',
  countdownTextColor: 'Texto contador',
  country: 'País',
  coupon: 'Cupón',
  couponCode: 'Código de descuento (opcional)',
  creatanaccount: 'Crear una cuenta',
  createTime: 'Tiempo de creación',
  createaccounttitle:
    'Cree su cuenta gratuita en nuestro plan básico, sin tarifas mensuales.',
  createfreeaccount: 'Crear cuenta gratuita',
  createpassword: 'Cree una contraseña',
  currencyConversionAnswer:
    'Después de pagar todos los pedidos, puedes retirar dinero en efectivo. Se admiten transferencias bancarias y retiros a través de Paypal.',
  currencyConversionTitle: '¿Problemas de conversión de moneda?',
  currentStoreName: 'Tienda actual:',
  customerBuysMore:
    'If the customer buys more and wants to cancel and refund, the refund shall be borne by Party B',
  date: 'Fecha',
  days: 'días',
  defaultDomainTips:
    'Este es el nombre de dominio gratuito proporcionado por USAdrop. Siempre funciona. Pero recomendamos construir el nuestro.',
  delete: 'Excluir',
  deleteSelected: 'Eliminar seleccionados',
  deleteSuccess: '¡Borrado exitoso!',
  deletedSuccessfully: 'Eliminado con éxito',
  deliveryTime:
    'The customer receives the goods, the delivery time is too long, exceeding the store time limit, refunds are borne by Party A',
  disable: 'Desactivar',
  disabledSuccessfully: 'Desactivado con éxito',
  discount: 'Descuento',
  discountAmount: 'Cantidad de descuento',
  discountPercent: 'Porcentaje de descuento',
  discountRate: 'Configuración de descuento',
  dnsNormal: 'La configuración de los registros DNS es normal',
  dnsNotConfigured: 'Registros DNS no configurados o no propagados.',
  dnsRecordsTitle: 'Registros DNS para tu tienda en línea',
  domain: 'Dominio',
  domainbtntext: 'Configurar',
  domaintitle: 'Configure el mismo dominio que su tienda de Shopify aquí.',
  eachSuccessfulTransaction:
    'Después de cada transacción exitosa de la Parte B, la Parte A retirará el 10% del monto de la transacción exitosa de la Parte B y mantendrá el margen rotatorio en la cuenta de la Parte A mientras lo transfiere a la Parte B. El margen rotatorio en la cuenta de la Parte A para cada transacción se mantendrá durante 45 días y el monto se liberará a la Parte B después de 90 días.',
  edit: 'Editar',
  editstore: 'Editar tienda',
  email: 'Correo electrónico.',
  emailContent: 'Contenido del Correo Electrónico',
  emailReminders: 'Configuración promocional',
  emailRemindersDesc:
    'Configura recordatorios por correo electrónico y descuentos en pedidos',
  emailTemplateConfig: 'Configuración de la plantilla de correo',
  emailTemplateConfigDesc: 'Contenido personalizado del correo',
  emailTitle: 'Tema del correo electrónico',
  embedPaymentMethods:
    'Enviar recordatorios por correo electrónico en diferentes momentos para animar a los clientes a completar el pago, mejorando la tasa de conversión de pedidos.',
  emptyCouponDesc:
    'Después de configurar el cupón, aparecerá una ventana emergente para reclamar el cupón tras completar el pago, alentando al usuario a usar el cupón para obtener una mejor oferta.',
  emptyCouponTitle: 'Configura tu cupón',
  enable: 'Activar',
  enableCouponTips:
    'Solo se puede activar un cupón a la vez. ¡Desactiva los demás antes de continuar!',
  enabledSuccessfully: 'Activado con éxito',
  end: 'Fin',
  endDate: 'Fecha de fin',
  enter: 'Entrar',
  entercorrectemail:
    'Por favor ingrese el formato correcto de correo electrónico',
  enteremailandpassword: 'Ingrese su correo electrónico y contraseña',
  example: 'Ejemplo',
  faqs: 'FAQs',
  firstPaymentChannel: 'Método de Pago para el Primer Pedido',
  firsttimeaNY: '¿Primera vez en USAdrop?',
  followInstructions: 'Sigue las instrucciones',
  followingPenalties:
    'Además de las multas mencionadas anteriormente, quienes violen gravemente las regulaciones estarán sujetos a las siguientes penalizaciones:',
  forBrazil: 'Para Brasil:',
  forMexico: 'Para México/Chile/Colombia/Perú:',
  forPaymentFailure:
    'For payment failure, the refund shall be borne by Party B',
  forShopify:
    'Cuando te registras en Shopify, tu tienda online obtiene una URL de myshopify.com.',
  forgetpassword: 'Olvidé mi contraseña',
  fullname: 'Nombre completo',
  goodsNum: 'artículos',
  gtm: 'Container ID',
  gtmRequired: 'Container ID is required',
  gtmDomain: 'URL del contenedor del servidor',
  gtmDomainRequired: 'URL del contenedor del servidor is required',
  googleid: 'ID de Medición',
  googlekey: 'Secretos de la API de Measurement Protocol',
  googleidRequired: 'Se requiere el ID de Medición',
  googlekeyRequired: 'Se requiere el API de Measurement Protocol',
  hasBeenSigned:
    'Logistics shows that it has been signed, but the customer has not received it, refunds are borne by Party A',
  hasquestions: '¿Tienes preguntas?',
  headerImage: 'Imagen de Encabezado',
  helpCenter: 'Centro de Ayuda',
  helpaddress: 'bento.me/enchentesrs',
  hi: 'Hola',
  holding: '1、Retención',
  home: 'Hogar',
  howtocontribute: 'Vea cómo contribuir en',
  howtoset: 'Cómo configurar',
  identifyyourself: 'Identifíquese',
  imitationBrand: 'Imitación/marca imitadora',
  inActive: 'INACTIVO',
  inativo: 'INACTIVO',
  info: 'Información',
  installtitle:
    'Instale el Pago Transparente de USAdrop en su tienda de Shopify.',
  invitationNumber: 'Número de invitación',
  invitationNumberError:
    'Por favor, ingrese su número de invitación para completar el registro',
  isConfirmDelete: '¿Seguro que quieres borrarlo?',
  kEmail: 'Correo Electrónico',
  kName: 'Nombre',
  learnMore: 'más información.',
  lengthLimit: 'La longitud debe ser de 3 a 8',
  letteringPattern:
    'Product quality (size, color difference, damage, stains, thread ends, odor, wrinkles, fading, shrinkage, lettering, pattern, logo, accessories), refunds are borne by Party A',
  like: 'me gusta',
  linkNewDomain: 'Vincular nuevo dominio',
  liquidatedDamages: 'Daños y sanciones liquidadas.',
  logaccount: 'Has iniciado sesión en:',
  loginsuccess: '¡Inicio de sesión exitoso!',
  logout: 'Cerrar sesión',
  logoutSYS: '¿Desea cerrar sesión en el sistema?',
  lougoutsuccess: '¡Cierre de sesión exitoso!',
  markAsActive: 'Marcar como ativo',
  markAsInactive: 'Marcar como inativo',
  min: 'mín',
  mydomain: 'Mi dominio',
  mydomains: 'Mis dominios',
  mydomainsdesc:
    'Administra tus dominios aquí. Vincula tus dominios y configúralos para que sean la dirección virtual de tu tienda y pago.',
  name: 'NOMBRE:',
  needhelp: 'Rio Grande do Sul necesita tu ayuda.',
  newaffiliations: 'Países nuevos',
  newpixel: 'Nuevo pixel',
  nextPage: 'Página Siguiente',
  backToMessages: 'Volver a mensajes',
  messageDetail: 'Detalle del mensaje',
  noNotifications: 'No hay notificaciones',
  notifications: 'Notificaciones',
  refresh: 'Actualizar',
  no: 'No',
  noDomain: 'Sin dominio',
  noStatus: 'Sin Estado',
  noUseDefaultDomain: '¡No uses el dominio de pago predeterminado de USAdrop!',
  noUseOrgin: 'No utilices http:// https:// ni www',
  nocountriesavailable: 'No hay países disponibles',
  nodatareadtitle: 'Lea nuestro artículo completo',
  nodatastartsell: 'Cuando comiences a vender, tus pedidos aparecerán aquí.',
  nodatatip1: 'Personaliza tu tienda con la apariencia de tu negocio!',
  nodatatip2: 'Ofrece diferentes métodos de pago.',
  nodatatip3: 'Agrega buenas fotos a tus productos.',
  nodatatip4:
    'Haz descripciones de productos atractivas y usa técnicas de SEO.',
  nodatatip5:
    'Invierte en tráfico pagado: anuncios en redes sociales y Google Shopping.',
  nodatatip6: 'Revisa si el precio de tus productos es atractivo.',
  nodatatip7: 'Ten un canal de atención al cliente para responder preguntas',
  nodatatips: '7 consejos rápidos para que hagas tu primera venta:',
  nodatatitle: 'Aún no hay pedidos para mostrar',
  nodeDescription: 'Descripción de la situación desencadenante',
  nodeName: 'Situación desencadenante',
  operation: 'Estado',
  order: 'Pedido',
  orderCancel: 'Cancelado',
  orderClosed: 'Cerrado',
  orderConversion: 'Estado del pedido',
  orderConversionTipUnpaid:
  'Recuperado mediante remarketing, pero aún no pagado.',
  orderConversionTipUnconverted: 'El cliente nunca realizó el pago.',
  orderConversionTipPaid:
    'Recuperado mediante remarketing y pagado correctamente.',
  orderConversionTipPending:
    'El cliente inició el pago, pero no lo completó.',
  orderConversionTipPaidStatus: 'Pago completado correctamente.',
  orderDeliver: 'Enviado',
  orderEnd: 'Completado',
  orderPaid: 'Pagado',
  orderReceived: 'Entregado',
  orderToAnalyze:
    'Para analizar el origen de los pedidos y ajustar los anuncios a tiempo. Además, nuestros datos son más precisos que los de Facebook.',
  orderWaitPay: 'Pendiente',
  ordernum: 'No. de Pedido',
  more: 'Más',
  orderCodesBatchTips:
    'Ingrese un No. de Pedido por línea, o sepárelos por comas',
  ordertime: 'Hora del Pedido',
  originurl: 'Dirección del sitio web',
  originurlexample: 'Ejemplo: tu-tienda.myshopify.com',
  originurlprefix:
    'La URL no puede contener los siguientes valores: www., https://, http://, /, .br',
  package:
    'If the customer refuses to accept the package and requests a refund, The refund shall be borne by Party B',
  partyAProvides:
    'La Parte A proporciona un servicio de garantía de reembolso para pedidos cooperativos a una tarifa del 1,5%. Si se comprueba que el motivo del reembolso es que el cliente no está satisfecho con el producto después de recibirlo, la tarifa de reembolso correrá a cargo de la Parte A y la Parte B no tendrá que asumir las pérdidas relacionadas. Para escenarios de uso específicos, consulte el apéndice del acuerdo del sistema.',
  partyAProvidesconsumers:
    'Para salvaguardar la estabilidad y el cumplimiento de los canales de pago, la Parte A será el proveedor exclusivo de los servicios de posventa para la Parte B. La Parte B autoriza plenamente a la Parte A a gestionar todos los asuntos de posventa y a proporcionar acceso a las cuentas de correo electrónico de posventa correspondientes. Cualquier gestión de posventa realizada por la Parte B se considerará excepcional y requerirá el consentimiento previo de la Parte A; en dichos casos, la Parte B otorgará a la Parte A acceso completo a las cuentas de correo electrónico de posventa pertinentes para su monitoreo en tiempo real. El incumplimiento de la presente cláusula facultará a la Parte A a suspender o cancelar de forma inmediata el acceso de la Parte B a los servicios de pago, sin responsabilidad alguna.',
  partyProvides:
    'La Parte A proporciona a la Parte B servicios de pago y liquidación de Internet transfronterizo, que incluyen:',
  password: 'Contraseña',
  payBy: 'PAGAR POR',
  payment: 'Pago',
  paymentDateAnswer:
    'Puede solicitar el retiro después de pagar la tarifa de cumplimiento del pedido. El retiro generalmente se procesará en un plazo de 1 a 2 días hábiles. El tiempo de llegada final depende de su banco.',
  paymentDateTitle:
    '¿Cuánto tiempo tarda en recibirse el retiro después de que lo inicio?',
  paymentDomain: 'Resolución de dominio CNAME',
  paymentRatesTitle: 'Pago y tarifas para cada país',
  paymentServicesToParty:
    'La Parte A proporciona servicios de pago a la Parte B, y la Parte B debe informar a la Parte A sobre la información de inicio de sesión de la tienda. La Parte A también proporciona a la Parte B servicios de consulta sobre información de transacciones y liquidaciones, y la Parte B debe cooperar con la Parte A para mantener conjuntamente la estabilidad de la cuenta del producto de pago.',
  paymentSetting: 'Configuración de pago',
  paymentTime: 'Tiempo de pago',
  paymentaffiliations: 'Configuración de pago',
  paymentaffiliationsdesc:
    'La configuración para realizar transacciones en su tienda y la configuración de idioma y país para la interfaz que se muestra a los clientes',
  shopifyCurrencyConfirmBRL:
    'Por favor, confirme que la moneda de su tienda Shopify está configurada en BRL.',
  shopifyCurrencyConfirmCLP:
    'Por favor, confirme que la moneda de su tienda Shopify está configurada en CLP.',
  shopifyCurrencyConfirmCOP:
    'Por favor, confirme que la moneda de su tienda Shopify está configurada en COP.',
  shopifyCurrencyConfirmEUR:
    'Por favor, confirme que la moneda de su tienda Shopify está configurada en EUR.',
  shopifyCurrencyConfirmGBP:
    'Por favor, confirme que la moneda de su tienda Shopify está configurada en GBP.',
  shopifyCurrencyConfirmMXN:
    'Por favor, confirme que la moneda de su tienda Shopify está configurada en MXN.',
  shopifyCurrencyConfirmPEN:
    'Por favor, confirme que la moneda de su tienda Shopify está configurada en PEN.',
  shopifyCurrencyConfirmSEK:
    'Por favor, confirme que la moneda de su tienda Shopify está configurada en SEK.',
  shopifyDomainUsedByOtherStore:
    "Este dominio ya está siendo utilizado por otra tienda de Shopify; por favor, cambia el estado de cualquier tienda que no estés usando a 'Inactiva'",
  confirmStoreConnectedWiio:
    'Confirme si su tienda está vinculada a Wiio Dropshipping.',
  confirmStoreConnectedUsaDrop:
    'Confirme si su tienda está vinculada a USADrop Dropshipping.',
  paymentbtntext: 'Configurar',
  paymentdoamin: 'Dominio de pago',
  paymentlanguage: 'Idioma de la página de pago',
  paymentoptions: 'Opciones de pago',
  paymentoptionsdesc: 'Las opciones de pago aceptadas en tu tienda.',
  paymenttitle: 'Configure los métodos de pago aceptados en su tienda.',
  personalInformationVerification: 'Verificación de la información personal',
  personalInformationVerificationSubTitle:
    'La verificación de la información implica su número de teléfono móvil.',
  phone: 'Teléfono',
  pixel: 'Píxel',
  pixelIDisRequired: 'Se requiere el ID del Pixel',
  pixelTokenisRequired: 'Se requiere el Token del Pixel',
  pixelexample:
    'Ejemplo: Un cliente ve tu anuncio, visita tu sitio web y realiza una compra. El pixel rastrea esto, ayudándote a saber qué anuncios generan más ventas.',
  pixelhelp:
    'Analiza el rendimiento de tus campañas de marketing, viendo cómo tus clientes interactúan con tus anuncios y tu tienda.',
  pixelid: 'ID del pixel',
  pixelname: 'Nombre del pixel',
  pixeltoken: 'Pixel token',
  platforms: 'PLATAFORMAS',
  pleaseFillTheRequiredFields: 'Por favor, complete los campos obligatorios',
  pleaseInput: 'Por favor ingrese',
  pleaseInputDomain: 'Por favor, introduce el dominio',
  pleaseSelect: 'Por favor seleccione',
  pleaseSelectDate: 'Seleccione una fecha',
  pleconfirmPWD: 'Por favor confirme su contraseña',
  pleinputPWD: 'Por favor ingrese una contraseña',
  popup: 'Popup',
  popupBackground: 'Fondo de Popup',
  popupConfig: 'Configuración de la ventana emergente',
  popupConfigDesc: 'Efecto de pop-up y reglas de ventanas emergentes',
  popupCycle: 'Ciclo emergente',
  popupCycleItem: 'Usuario primerizo, emergente cada {input} días',
  preview: 'Vista previa',
  previousPage: 'Página Anterior',
  priceTerms: 'Condiciones de precios',
  privacypolicy: 'Política de Privacidad de USAdrop',
  processingTime:
    'La Parte A llevará a cabo todos los pedidos de la tienda de la Parte B y actualizará el tiempo de procesamiento, el tiempo de envío, las descripciones de productos, etc., de acuerdo con los requisitos de la Parte A. Si hay elementos que deben ajustarse, como productos agotados o productos similares, la Parte B debe completar el ajuste o eliminación en un tiempo de 12 horas.',
  product: 'Producto',
  productSpecifications:
    'Wrong product, color, size, other SPU, specifications, refunds are borne by Party A',
  productsImitation:
    'Imitation products_imitation brands , the refund shall be borne by Party B',
  propertyRights:
    'Prohibición de subir y vender productos que infringen los derechos de propiedad intelectual',
  protocolBtnPrefix: 'Estoy de acuerdo con',
  protocolBtnTitle:
    'los Términos y Condiciones de Pago, al igual que con la Política de Privacidad',
  protocolDialog: 'Acuerdo de Usuario',
  questionsSupport:
    'Si tienes alguna pregunta, utiliza nuestro material de soporte que aparece a continuación:',
  recommendSize: 'Tamaño recomendado: {input}',
  recoverpassowrd: 'Recuperar contraseña',
  recovertitle: 'Ingrese su dirección de correo electrónico abajo',
  rectifiedAccording: `For refunds of orders that are not rectified according to Party A's requirements, the refund shall be borne by Party B`,
  redirectLink: 'Enlace de Redirección',
  refundGuaranteeFees: 'Tarifas de garantía de reembolso',
  refundGuaranteeTerms: 'Términos de Garantía de Reembolso',
  refundShallBe:
    'If the product is not reviewed and the product is out of stock, the refund shall be borne by Party B',
  refundsAreBorne:
    'Logistics information shows that it has not been delivered/updated for a long time, refunds are borne by Party A',
  refundsAreGiven:
    'The product has been reviewed, the product is out of stock and refunds are given to the customer, refunds are borne by Party A',
  register: 'Registrarse',
  registersuccess: '¡Registro exitoso!',
  registertips:
    'Usaremos tus datos para crear tu cuenta de acceso y enviar información que te ayude a activar tu tienda.',
  requestNumber: 'NÚMERO DE ORDEN',
  requests: 'Pedido',
  requestsCancellation:
    'El pedido no ha sido enviado y el cliente solicita la cancelación',
  save: 'Guardar',
  saveFields: 'Después de rellenar los campos, guarda lo que has rellenado.',
  saveSuccessfully: ' Guardado exitosamente',
  search: 'Buscar',
  secondarydomains: 'Dominios secundarios',
  selectCountry: 'Seleccione País',
  selectTimeZone: 'Seleccione Zona Horaria',
  service: 'Servicio',
  serviceemail: 'Correo electrónico de atención al cliente',
  setUpDomain:
    'Configura tu dominio con tu proveedor siguiendo los pasos a continuación.',
  settings: 'Configuración',
  settlementPeriod:
    'Extensión del período de liquidación o suspensión de la liquidación; La Parte A tiene el derecho de rescindir el Contrato y no devolverlo a la Parte B. El monto no liquidado y el depósito se liquidarán en un momento acordado diferente después de seis meses.',
  shipped:
    'The order time is less than or equal to 3 days, the order has been shipped, and the customer requests to cancel and refund, and the refund shall be borne by Party B',
  shopify: 'Shopify',
  shopifybtntext: 'Instalar',
  shopifytitle: 'Instale el Pago Transparente en su tienda de Shopify.',
  skipshoppingcart: 'Saltar carrito de compras',
  specificRates: '3、Tarifas específicas',
  specificUsageScenarios:
    'Los reembolsos generados por otros métodos serán asumidos por la Parte A. Para escenarios de uso específicos, haga clic aquí para obtener',
  sslCertificate: 'Certificado SSL',
  start: 'Inicio',
  startDate: 'Fecha de inicio',
  startUsing: 'Activo',
  startconfig: 'Comienza a configurar aquí',
  status: 'Estado',
  step1Content:
    'Ve al sitio web de tu proveedor de dominio. Busca la sección de configuración de registros DNS.',
  step1Title: 'PASO 1: ACCEDE AL PANEL DE TU PROVEEDOR',
  step2Content:
    'En tu proveedor, en la sección de configuración de registros DNS, añade la información a continuación. Llena cada campo con la información correspondiente:',
  step2Title: 'PASO 2: ACCEDE AL PANEL DE TU PROVEEDOR',
  step3Content:
    'Después de completar correctamente las entradas anteriores con tu proveedor de dominio, debes esperar un tiempo para que la información se propague. Este proceso suele tardar hasta 4 horas.',
  step3Title: 'PASO 3: ESPERA LA PROPAGACIÓN',
  storeAccessingUrl: 'Dirección de la tienda online',
  storeBinding: 'Vincular Tienda',
  storeBindingSettings: 'Configuración de la tienda',
  storeLogo: 'Logotipo de la tienda',
  storeLogoLimitTips: 'Tamaño recomendado: 230*50, dentro de 200 KB',
  orderImage: 'Volumen de pedidos de la tienda - Últimos 30 días',
  orderRemark: 'Observación del pedido',
  orderImageLimitTips: 'Se admiten varias imágenes',
  viewExample: 'Ver ejemplo',
  storename: 'Nombre de la Tienda',
  termsofuse: 'términos de uso',
  theCheckoutPage:
    'Cantidad de descuento/Porcentaje: En la página de pago, establezca un monto/porcentaje de descuento fijo para atraer a los clientes a elegir este método de pago.',
  theProductsSold:
    'Los productos vendidos en el sitio web incluyen productos no autorizados por la marca o que utilizan marcas no autorizadas por la marca, así como otros productos de marcas; infracción de propiedad intelectual no relacionada con marcas, que incluye pero no se limita a: películas, videos, canciones, juegos, obras de animación y sus productos periféricos, incluyendo pero no limitado a figuras, accesorios y equipos de personajes.',
  theRefundShall:
    'If the customer receives the goods and the delivery time is too long and it does not exceed the store time limit, the refund shall be borne by Party B',
  timezone: 'Zona horaria',
  tips: 'Consejos',
  toEmbedPaymentMethods: 'Para integrar métodos de pago.',
  toenter: 'Para entrar',
  tosave: 'Guardar',
  total: 'Total',
  trackingNumber: 'Número de seguimiento',
  transactionSettlement:
    'La Parte B acepta que la Parte A deduzca las tarifas anteriores del monto de liquidación de las transacciones de la Parte B.',
  transferPlatform: 'Plataforma de Pedidos',
  tutorial: 'Tutorial',
  type: 'TIPO:',
  typeofintegration: 'Tipo de integración',
  typepassword: 'Escriba su contraseña',
  unauthorized:
    'For unauthorized transactions, the refund shall be borne by Party B',
  unauthorizedTransaction: 'Transacción no autorizada',
  unconvertedOrder: 'Pedido no realizado',
  update: 'Actualizar',
  urlDisplayed:
    'La URL que aparece en el navegador cuando los clientes visitan tu tienda online es un dominio personalizado.',
  usedNormally: 'Cannot be used normally, refunds are borne by Party A',
  value: 'VALOR:',
  wantsToCancel:
    'El cliente compra más de lo necesario y desea cancelar y solicitar el reembolso',
  whatisapixel: '¿Qué es un Pixel?',
  whatsAppTemplate: 'Plantilla de WhatsApp',
  whichTimeZoneSetTitle: '¿Qué zona horaria se debe configurar?',
  withdrawalFeeAnswer:
    'Depende de la tarifa de tu banco. Cada banco tiene tarifas diferentes.',
  withdrawalFeeTitle: '¿Cuáles son las tarifas por retiros?',
  withdrawalMethodAnswer:
    'Después de pagar todos los pedidos, puedes retirar dinero en efectivo. Se admiten transferencias bancarias y retiros a través de Paypal.',
  withdrawalMethodTitle:
    '¿Cómo retirar efectivo y cuáles son los métodos de retiro?',
  yes: 'Sí',
  mismatched: 'La Parte B',
  mustNotSell:
    'no deberá vender productos de marca ni incluir logotipos o elementos de marca en las descripciones de los productos.',
  brandIconsMust:
    'En caso de que la Parte A detecte productos de marca no autorizados, productos ilegales o productos no coincidentes en la tienda de la Parte B, la Parte A suspenderá todos los pagos a la tienda de la Parte B en un plazo de 6 horas y detendrá todos los desembolsos. La Parte A tendrá el derecho de procesar reembolsos para cualquier pedido no conforme o que infrinja las políticas, y todos los costos, pérdidas y gastos derivados de dichas situaciones serán asumidos exclusivamente por la Parte B. El monto específico de la multa se muestra en el ',
  theRefund:
    'Si el motivo del reembolso cae en las siguientes cinco situaciones después de la verificación, el reembolso será asumido por la Parte B: ',
  refundGuarantee: 'Términos de Garantía de Reembolso.',
  priceList: 'Lista de precios',
  Holding: 'Retención (Holding)',
  appendixTwo: 'Apéndice 2.',
  paymentPriceList: 'Lista de precios de pago',
  howDoes: '¿Qué es Dropshipping y cómo funciona?',
  whatIsPayment: '¿Qué es el Pago USAdrop?',
  differenceDropshipping:
    'La diferencia entre pago contra reembolso y Dropshipping',
  howsySterm: 'Cómo utilizar USAdrop sistema',
  howShopifyAPI: 'Cómo configurar la API de Shopify',
  howDomain: 'Cómo configurar un Dominio',
  howPixel: 'Cómo configurar el píxel de Facebook',
  howCoupon: 'Cómo configurar un Cupón',
  pleaseShopifyStore:
    'Por favor, asegúrate de que el dominio esté conectado a tu tienda Shopify!',
  feeTerms: 'Cláusula de gastos',
  noRefundGuarantee: 'No hay tarifa de garantía de reembolso en Brasil',
  deleteShopify:
    'Cómo eliminar o agregar el botón dinámico "Comprar ahora" y el botón "Agregar al carrito" en Shopify',
  stepOne: 'Paso 1, navegue a “Tienda online” → “Temas” → “Personalizar”',
  stepTwo:
    'Paso 2: Vaya a “Productos” → “Producto predeterminado” → ingrese a la página de descripción del producto',
  stepThree:
    'Paso 3: Haga clic en "Botones de compras" → Haga clic para activar "Mostrar botones de pago dinámico" → "Guardar"',
  dynamicCheckoutButton: 'Cómo configurar el botón de pago dinámico',
  personalInformationTitle: 'Información de mi cuenta',
  personalInformationSubTitle:
    'La verificación de la información de la cuenta es un proceso para garantizar que su información sea precisa y actualizada. Implica verificar su número de teléfono para asegurarse de que es correcto y actualizado.',
  personalInformationTips:
    'Nota: \n' +
    'Para garantizar la autenticidad de su información de identidad, necesitamos' +
    ' verificar su número de teléfono móvil. El nombre y el número de teléfono móvil no se pueden modificar' +
    ' después de la verificación y vinculación. Si no puede recibir el código de verificación o necesita' +
    ' modificarlo, comuníquese con el servicio de atención al cliente o el agente de USAdrop Payment.',
  contactName: 'Nombre de contacto',
  contactPhone: 'Número de teléfono',
  contactPhoneAreaCode: 'Código de área telefónica',
  getVerificationCode: 'OBTENER CÓDIGO DE VERIFICACIÓN',
  verificationCode: 'Código de verificación',
  pleaseEnter: 'Por favor ingrese {input}',
  pleaseSelect2: 'Por favor seleccione {input}',
  fulfillmentPlatform: 'Plataforma de Cumplimiento',
  pleaseEnterCorrect: 'Por favor, ingrese {input} correcto',
  sendSuccessfully: 'Envío exitoso',
  submitSuccessfully: 'Presentación exitosa',
  serviceUnavailable: 'El servicio no está disponible',
  loginExpired: 'Sesión expirada, inicie sesión nuevamente',
  toVerification: 'A la verificación',
  activeCustomerPaymentTips:
    'La verificación de datos personales aún no se ha completado, por lo que el servicio de pago no puede ser utilizado.',
  activeCustomerPaymentTips2: `Haga clic en "Verificación de la información personal" para completar el proceso de validación de la información.`,
  skipCartTips1:
    'Esta función ayuda a aumentar las tasas de conversión de pedidos únicos, pero reduce las tasas de añadir al carrito. Habilítela según sea necesario.',
  skipCartTips2: `Cuando se activa, USAdrop Payment deshabilitará el botón "Add to Cart" (Añadir al Carrito) de Shopify y conservará únicamente los botones de pago dinámicos. Los clientes que hagan clic en estos botones serán redirigidos directamente a la página de pago.`,
  skipCartTips3:
    '(Si el botón de pago no es visible en las páginas de productos después de activar esta función, siga el tutorial para habilitar los botones de pago dinámicos:',
  advertisingMaterial: 'Tutorial de material publicitario',
  violationRecord: 'Registros de Infracciones',
  store: 'Almacenar',
  state: 'Estado',
  deadline: 'Fecha límite',
  needModified: 'Need to be modified',
  reviewing: 'Revisando',
  completed: 'Terminado',
  types: 'Tipo',
  link: 'Estado',
  picture: 'Imagen',
  details: 'Detalles',
  overdue: 'Atrasado',
  rejected: 'Rechazado',
  operate: 'funcionar',
  complete: 'Completado',
  completeTips:
    '¡Estamos a punto de presentar la revisión, ¡ por favor, asegúrese de que la modificación se ha completado según sea necesario!',
  remark: 'Observación',
  remarkPlaceholder: 'Por favor, ingrese una observación',
  pleaseInputRemark: 'Por favor, complete la observación',
  facebookPixel: '¿Cómo configurar Facebook Pixel?',
  googlePixel: '¿Cómo configurar Google Pixel?',
  themeColor: 'Color del Tema',
  themeColorTips:
    'Puede usar esta configuración para modificar el color del tema de la interfaz de "checkout"',
  buttonColor: 'Color del Pagar ahora',
  buttonColorTips:
    'Puede usar esta configuración para cambiar el color del botón "Pagar ahora".',
  terminationAgreement: 'Terminación del Contrato',
  installment: 'Cuota',
  unhandledStores: 'Tienes tiendas ilegales',
  pixelTop1: 'GTM ya está vinculado. No puedes agregar otro píxel.',
  pixelTop2: 'Desactiva el píxel actual antes de usar GTM.',
  pixelTop3:
    'GTM y otros píxeles no pueden funcionar al mismo tiempo. ¿Necesitas ayuda? Contacta a tu agente.',
  successVideoTop: 'Historias de Éxito Reales',
  paypalTop:
    'Por favor contacte a nuestro agente para activar el pago por Paypal.',
  errorMessage: 'Se produjo un error en el servidor',
  wiioRechargeTitle: 'Aviso',
  wiioRechargeDesc:
    'Por favor, pague la tarifa mensual para usar la plataforma.',
  wiilRechargeConfirm: 'Ir a USAdrop',
  orderPageDesigner: 'Editor de Checkout',
  export: 'Exportar',
  exporting: 'Exportando...',
  unknownError: 'Error desconocido',
  downloadSuccess: 'Descarga exitosa',
  defaultExportNotice:
    'Por defecto se exportarán los registros de los últimos 30 días; puede seleccionar un rango máximo de 30 días',
  pageStyleConfig: 'Configuración de Estilo de la Página',
  reset: 'Restablecer',
  limitedTimeOffer:
    'Oferta por tiempo limitado. ¡Haz tu pedido ahora y disfruta del descuento!',
  countdownToEnd: 'Tiempo restante para que termine el evento:',
  configLoadedSuccess: 'Los datos de configuración se cargaron correctamente',
  configLoadedUseDefault:
    'No se pudieron cargar los datos de configuración, usando valores predeterminados',
  configLoadFailed:
    'No se pudo obtener la configuración, revise la red o el servicio',
  confirmRestore:
    '¿Seguro que desea restaurar la configuración? Esta acción es irreversible',
  warning: 'Advertencia',
  confirmReset: 'Confirmar restablecimiento',
  submitSuccess: 'Enviado con éxito',
  checkoutConfigSaved:
    '¡La configuración de la página de pago se guardó y se aplicó correctamente!',
  saveConfigFailed:
    'Error al guardar la configuración, inténtelo de nuevo más tarde.',
  visualSizeConfig: 'Configuración Visual y de Tamaño',
  width: 'Ancho',
  height: 'Altura',
  textAndCountdownConfig:
    'Configuración de Texto y Cuenta Regresiva (Copy de Marketing)',
  textContent: 'Contenido del Texto',
  enterMarketingCopy: 'Ingrese el texto de marketing',
  fontSize: 'Tamaño de Fuente',
  fontColor: 'Color de Fuente',
  fontWeight: 'Grosor de Fuente',
  selectWeight: 'Seleccione grosor',
  countdownSettings: 'Configuración de Cuenta Regresiva',
  enableCountdown: 'Habilitar cuenta regresiva',
  countdownPrefix: 'Prefijo de la cuenta regresiva',
  examplePrefix: 'Ejemplo: Hasta el final',
  endTime: 'Hora de finalización',
  selectEndTime: 'Seleccione la hora de finalización de la cuenta regresiva',
  textSpacing: 'Espaciado entre Texto/Temporizador',
  realtimePreview: 'Vista previa en tiempo real',
  eventEnded: 'El evento ha terminado',
  rowInfo: 'Información de la fila {index}',
  icon: 'Ícono',
  title: 'Título',
  bottomTextConfig: 'Configuración del Texto Inferior',
  text: 'Texto',
  suggestedSize: 'Tamaño sugerido',
  logo: 'Logo',
  banner: 'Banner',
  safetyInfo: 'Información de Seguridad',
  securityIcons: 'Íconos de Seguridad',
  description: 'Descripción',
  confirmSavePageStyle:
    '¿Está seguro de que desea guardar la configuración actual del estilo de la página? Una vez guardada, se aplicará inmediatamente en la página de pago.',
  getCodeTip:
    'Por favor, complete primero el dominio de la tienda, la clave de API y la clave secreta.',
  getCode: 'Obtener código',
  token_helper_tip:
    'Obtenga el Access Token automáticamente usando sus credenciales de Dev Dashboard.',
  copySuccess: '¡Copiado!',
  paymentDetails: 'Detalles de pago',
  viewPaymentCode: 'Código de pago',
  paymentLink: 'Enlace de pago',
  paymentCodeDetails: 'Código de pago',
  barcode: 'Código de barras',
  pixPaymentCode: 'Código de pago PIX',
  copyPaymentCode: 'Copiar código de pago',
  downloadPaymentImage: 'Descargar imagen',
  paymentCodeValidUntil: 'Válido hasta',
  paymentImageUnavailable: 'No se pudo generar la imagen de pago.',
  copyFailed: 'No se pudo copiar. Seleccione y copie el código manualmente.',
  pleaseFillInClientIdAndSecret:
    'Por favor, complete el Client ID (API Key) y Secret (API Secret Key)',
  pleaseEnterClientIdAndSecret:
    'Por favor, ingrese el Client ID (API Key) y Secret (API Secret Key)',
  pleaseFillInClientIdAndSecretFirst:
    'Por favor, complete primero el Client ID (API Key) y Secret (API Secret Key)',
  pleaseContactAgent: 'Por favor contacte al agente',
  createStoreMexicoUSAdropPaymentsTitle: 'Crea tu Tienda Shopify desde Cero',
  couponDisplayConfig: 'Visualización del cupón',
  displayMode: 'Modo de visualización',
  couponDisplayExpand: 'Expandido',
  couponDisplayHide: 'Oculto',
  couponHideModeTipStart:
    'Cuando está habilitado, el campo de cupón se oculta por defecto. Si has configurado un',
  couponHideModeTipEnd:
    'y está activo, se aplicará automáticamente cuando un cliente realice un segundo pedido. Si no quieres que los clientes usen códigos de descuento, establece el estado del cupón en "Deshabilitado".',
  couponDisplayCollapse: 'Colapsado',
  couponUnselected: 'No seleccionado',
  couponNoAvailable: 'No hay cupones disponibles',
  couponNoCode: 'No es necesario rellenar',
  productPrice: 'Productos',
  productDiscount: 'Descuento',
  productShipping: 'Envío',
  free: 'Gratis',
  apply: 'Aplicar',
  orderPreviewPriceProduct: '$9999.00',
  orderPreviewPriceDiscount: '-$0.00',
  orderPreviewPriceTotal: '$9999.00',
  uponTransactionRisks: `En caso de que el consumidor presente una solicitud de reembolso, la Parte A se reserva el derecho, a su exclusiva discreción, de procesar el reembolso de la transacción, total o parcialmente, con el fin de mitigar riesgos transaccionales más graves o potenciales.`,
  howGooglePixel: 'Cómo configurar el píxel de Google',
  fulfillmentPlatformTips: 'Importante: Los pedidos pagados con nuestra solución de pago deben ser gestionados a través de nuestro servicio de fulfillment.'
}
